export enum ModalType {
  BUY,
  MAKE_OFFER,
  BID,
  SALE,
  UP_AUCTION,
  ACCEPT,
}
